import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/app/model-registry/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/model-registry/models', replace: true })
  },
})
